import cn from '@integrations/classnames'
import type { ReactNode } from '@integrations/react'
import { tr } from 'mmfintech-commons'
import { MMRadioGroup } from 'mmfintech-portal-commons'
import styles from './QuestionnaireYesNoField.module.scss'

interface Props {
  heading: ReactNode
  selected?: string
  setSelected: (value: string) => void
  variant?: string
  yesDataTest?: string
  noDataTest?: string
}

function QuestionnaireYesNoField({ heading, selected, setSelected, variant, yesDataTest, noDataTest }: Props) {
  return (
    <div className={cn(styles['radio-button-wrapper'], 'radio-button-wrapper')}>
      <div className={cn(styles['heading'], 'heading')}>{heading}</div>
      <MMRadioGroup
        direction='horizontal'
        options={[
          {
            value: 'true',
            label: tr('FRONTEND.QUESTIONNAIRE.LABEL_YES', 'Yes'),
            'data-test': yesDataTest
          },
          {
            value: 'false',
            label: tr('FRONTEND.QUESTIONNAIRE.LABEL_NO', 'No'),
            'data-test': noDataTest
          }
        ]}
        selected={selected}
        setSelected={setSelected}
        variant={variant}
      />
    </div>
  )
}

export default QuestionnaireYesNoField
